import { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Popover, SvgIcon } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Button, ConditionalTooltip } from '@atoms';
import styles from './styles';

interface ThreeDotsMenuProps {
  options: {
    text: string;
    canViewOption: boolean;
    tooltipText?: string;
    icon?: React.ReactNode;
    disabled?: boolean;
    onClick: () => void;
  }[];
}

/**
 * Three dots menu component
 */
const ThreeDotsMenu = ({ options }: ThreeDotsMenuProps) => {
  const [showPopover, setShowPopover] = useState<null | HTMLElement>(null);

  /**
   * open menu
   */
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setShowPopover(event.currentTarget);
  };

  /**
   * close menu
   */
  const handleClose = () => {
    setShowPopover(null);
  };

  if (options.every((option) => !option.canViewOption)) {
    return null;
  }

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={Boolean(showPopover)}
        anchorEl={showPopover}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={styles.containerPopover}>
          {options.map(
            (button, index) =>
              button.canViewOption && (
                <ConditionalTooltip key={index} tooltipText={button.tooltipText}>
                  <Button
                    customStyle={styles.button}
                    onClick={() => {
                      button.onClick();
                      handleClose();
                    }}
                    text={button.text}
                    startIcon={button.icon && <SvgIcon>{button.icon}</SvgIcon>}
                    disabled={button.disabled}
                  />
                </ConditionalTooltip>
              )
          )}
        </Box>
      </Popover>
    </>
  );
};

export default ThreeDotsMenu;
